import includes from 'lodash/includes';
import { reduceValidationResults } from '../validators';
import { t } from '../../../utils/translate';

export const enforceRanking = (state, action) => ({
  ...state,
  rows: state.rows.reduce((newRows, row) => {
    const isSameVal = row.values[0] === action.value;
    const isSameRow = row.index === action.rowIndex;
    if (isSameVal && !isSameRow) {
      return newRows.concat([
        {
          ...row,
          values: [],
        },
      ]);
    } else {
      return newRows.concat([row]);
    }
  }, []),
});

// Require one value per row except Other
export const matrixRequiredValidator = state => {
  const hasValues = state.rows.reduce(
    (valid, row) => (row.other ? valid : valid && !!row.values.length),
    true
  );
  const isForgiven = state.rows.some(row => !row.isTouched);
  const isValid = hasValues || isForgiven;
  const errorMessages = isValid ? null : [t('must_make_one_entry_per_row')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const forceExclusiveValue = exclusiveValue => (state, action) => {
  // only change the state if it was a change action (not blur, not submit, etc)
  if (!action.type.match(/CHANGE/)) {
    return state;
  }
  const values =
    action.value === exclusiveValue
      ? state.values.filter(val => val === exclusiveValue)
      : state.values.filter(val => val !== exclusiveValue);
  return {
    ...state,
    values,
  };
};

export const matrixForceExclusiveValue = exclusiveValue => (state, action) => ({
  ...state,
  rows: state.rows.map(row =>
    row.index === action.rowIndex
      ? forceExclusiveValue(exclusiveValue)(row, action)
      : row
  ),
});

export const selectListOtherValidator = state => {
  const otherSelected = includes(state.values, 'other');
  const hasOtherValue = !!state.otherValue.trim().length;
  // ^^ whats with the !!
  const isForgiven = !state.isOtherTouched;
  // ^^ why isForgiven? lanuage
  const isOtherValid =
    (otherSelected && hasOtherValue) ||
    (!otherSelected && !hasOtherValue) ||
    isForgiven;
  const isValid = isOtherValid;
  const errorMessages = isValid ? null : [t('other_verbatim')];
  return reduceValidationResults(state, {
    errorMessages,
    isOtherValid,
    isValid,
  });
};

export const selectListRequiredValidator = state => {
  const hasValues = !!state.values.length;
  const isForgiven = !state.isTouched;
  const isValid = hasValues || isForgiven;
  const errorMessages = isValid ? null : [t('must_choose_at_least_one')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const maxChoicesValidator = props => state => {
  const { values } = state;
  const { max_choices } = props;
  const isOverMax = values.length > max_choices;
  const isValid = !isOverMax;
  const errorMessages = isValid
    ? null
    : [t('must_be_fewer_than', [max_choices])];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const matrixMaxChoicesValidator = props => state => {
  const { max_choices } = props;
  const isOverMax = state.rows.some(row => row.values.length > max_choices);
  const isValid = !isOverMax;
  const errorMessages = isValid
    ? null
    : [t('must_be_fewer_than_x_per_row', [max_choices])];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const minChoicesValidator = props => state => {
  const { min_choices } = props;
  const isUnderMin = state.values.length < min_choices;
  const isValid = !isUnderMin;
  const errorMessages = isValid ? null : [t('must_be_at_least', [min_choices])];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};

export const matrixMinChoicesValidator = props => state => {
  const { min_choices } = props;
  const isUnderMin = state.rows.some(row => row.values.length < min_choices);
  const isValid = !isUnderMin;
  const errorMessages = isValid
    ? null
    : [t('must_be_at_least_x_per_row', [min_choices])];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
  });
};
